export default __webpack_public_path__ + "static/media/home.9ae33fba.svg";